import PropTypes from 'prop-types'
import React, { Component } from 'react'
import './gammaddathaksalava.css'

export class GammaddaThaksalava extends Component {
  static propTypes = {}

  render() {
    return (
      <div className="bg-[#fdf7f0] py-15 px-4 md:px-16 custom-padding">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-3xl md:text-5xl font-bold mb-6">Gammadda Thaksalava</h1>
        <p className="text-base md:text-lg text-gray-700 mb-8">
          COVID19 forced schools to close and rely on online education to teach the syllabus.
          However many students didn’t have data coverage or were unable to access the internet due to
          not having devices to connect or being unable to afford data plans. Gammadda eliminated the need
          of a device or internet plans to access a basic human right such as education. This is where
          Gammadda brought about unfettered access. Everyone had equal access to quality education through
          our Free-to-Air tuition classes aired on both Sirasa TV and Shakthi TV which were then archived on YouTube.
        </p>

        <div className="aspect-w-16 aspect-h-9 mb-10" style={{ Width: '1000px', height: 'auto' }}>
          <iframe
            className="w-full h-full custome-iframe"
            src="https://www.youtube.com/embed/39SOhrCM9uM?rel=0&controls=1&autoplay=0&mute=0&start=0"
            title="Gammadda Thakshalawa"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div>

        <div className="text-left space-y-10">
          {/* Ordinary Levels */}
          <div className="playList">
            <h1 className="m-4">Ordinary Levels</h1>
            <p className="text-gray-700 mb-4">
              Lessons on G.C. E Ordinary Level subjects were telecast on weekdays from 08 AM to 09 AM with a
              same-day repeat from 04 PM to 05 PM. Additionally revision classes were held to fortify the
              aptitude of the students with revision papers that were made available to the students by
              calling our hotline (0777600040). Students could also watch each session on our YouTube session
              if there was something they had missed.
            </p>
            <a
              href="https://youtube.com/playlist?list=PLzoeiMAHbWMjF9VgFhkFDGaEwMXmL4nao"
              target="_blank"
              rel="noopener noreferrer"
              className="text-deco"
            >
              View Playlist
            </a>
          </div>

          {/* Grade 5 Scholarship */}
          <div className="playList">
            <h1 className=" m-4">Grade 5 Scholarship</h1>
            <p className="text-gray-700 mb-3">
              Educational programs aimed at the Grade 05 Scholarship Examination were telecast on weekdays from
              9 AM to 10 AM with a repeat telecast scheduled for the day from 03 PM to 04 PM on Sirasa TV.
              Supplementary materials were made available to students who called our hotline (0777600040).
            </p>
            <a
              href="https://youtube.com/playlist?list=PLzoeiMAHbWMjw71C_UZEH1EQDPrq1Kkap"
              target="_blank"
              rel="noopener noreferrer"
              className=" text-deco" >
              View Playlist
            </a>
          </div>

          {/* Meinhar Palli */}
          <div className="playList">
            <h1 className="m-4">Meinhar Palli</h1>
            <p className="text-gray-700 mb-2">
              Free-To-Air classes for Tamil Medium students were aired on Shakthi TV from 06 AM to 07 AM on weekdays.
              Additionally Tamil language scholarship classes were held at 06 AM on Saturdays and Sundays on Shakthi TV
              with a re-telecast on TV One at 06 PM. Revision classes were held to fortify the aptitude of the students
              with revision papers and supplementary material that were made available to the students by calling our
              hotline (0777600040). Students could also watch each session on our YouTube session if there was something
              they had missed.
            </p>
            <a
              href="https://youtube.com/playlist?list=PLY5Vy1Ynx1y7-qG2wTVQyX9rm_VO8_cN6"
              target="_blank"
              rel="noopener noreferrer"
              className="text-deco"
            >
              View Playlist
            </a>
          </div>
        </div>
      </div>
    </div>
    )
  }
}

export default GammaddaThaksalava